"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconEdit = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.714 7.804a.75.75 0 01.101 1.494l-.101.007H.764a.75.75 0 01-.1-1.495l.102-.006h4.949zm17.539 0a.75.75 0 01.101 1.494l-.101.007H10.722a.75.75 0 01-.102-1.494l.102-.006h12.53z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.007 5.522a3.032 3.032 0 110 6.065 3.032 3.032 0 010-6.065zm0 1.5a1.532 1.532 0 100 3.065 1.532 1.532 0 000-3.065zm10.289 6.738a.75.75 0 00-.102 1.493l.102.007h4.949a.75.75 0 00.101-1.493l-.101-.007h-4.95zm-17.539 0a.75.75 0 00-.102 1.493l.102.007h12.53a.75.75 0 00.102-1.493l-.101-.007H.757z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.003 11.478a3.032 3.032 0 100 6.064 3.032 3.032 0 000-6.064zm0 1.5a1.532 1.532 0 110 3.064 1.532 1.532 0 010-3.064z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconEdit, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;